// extracted by mini-css-extract-plugin
export default {"postcon":"postcon__urP07","container":"container__c5I6q","left":"left__h-F4i","title":"title__yG-bX","tags":"tags__KTUnP","content":"content__VK6BK","right":"right__uXhIM"};